import { render, staticRenderFns } from "./Standard.vue?vue&type=template&id=cd50058e&scoped=true&"
import script from "./Standard.vue?vue&type=script&lang=js&"
export * from "./Standard.vue?vue&type=script&lang=js&"
import style0 from "./Standard.vue?vue&type=style&index=0&id=cd50058e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd50058e",
  null
  
)

export default component.exports